import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, NodeExtension, ExtensionTag, isElementDomNode, omitExtraAttributes, joinStyles } from '@remirror/core';
import { ExtensionColumnsMessages } from '@remirror/messages';

var _excluded = ["count", "fill", "gap", "ruleColor", "ruleStyle", "ruleWidth", "width"],
    _excluded2 = ["style"];

var _dec, _dec2, _class, _class2;
var toggleColumnsOptions = {
  icon: _ref => {
    var attrs = _ref.attrs;
    return {
      name: 'layoutColumnLine',
      sup: attrs === null || attrs === void 0 ? void 0 : attrs.count
    };
  },
  label: _ref2 => {
    var t = _ref2.t,
        attrs = _ref2.attrs;
    return t(ExtensionColumnsMessages.LABEL, {
      count: attrs === null || attrs === void 0 ? void 0 : attrs.count
    });
  },
  description: _ref3 => {
    var t = _ref3.t,
        attrs = _ref3.attrs;
    return t(ExtensionColumnsMessages.DESCRIPTION, {
      count: attrs === null || attrs === void 0 ? void 0 : attrs.count
    });
  }
};
var DEFAULT_COLUMN_ATTRIBUTES = {
  count: 2,
  fill: 'auto',
  gap: 'inherit',
  ruleColor: 'inherit',
  ruleStyle: 'none',
  ruleWidth: 'inherit',
  width: 'inherit'
};
var COLUMN_DATA_ATTRIBUTE = 'data-column-type';
var ColumnsExtension = (_dec = extension({
  defaultOptions: {
    defaults: DEFAULT_COLUMN_ATTRIBUTES
  },
  staticKeys: ['defaults']
}), _dec2 = command(toggleColumnsOptions), _dec(_class = (_class2 = class ColumnsExtension extends NodeExtension {
  get name() {
    return 'columns';
  }

  createTags() {
    return [ExtensionTag.Block];
  }

  createNodeSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({}, override), {}, {
      content: 'block+',
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        count: {
          default: this.options.defaults.count
        },
        fill: {
          default: this.options.defaults.fill
        },
        gap: {
          default: this.options.defaults.gap
        },
        ruleColor: {
          default: this.options.defaults.ruleColor
        },
        ruleStyle: {
          default: this.options.defaults.ruleStyle
        },
        ruleWidth: {
          default: this.options.defaults.ruleWidth
        },
        width: {
          default: this.options.defaults.width
        }
      }),
      parseDOM: [{
        tag: "div[".concat(COLUMN_DATA_ATTRIBUTE, "]"),
        getAttrs: node => {
          if (!isElementDomNode(node)) {
            return false;
          }

          var _node$style = node.style,
              columnCount = _node$style.columnCount,
              columnFill = _node$style.columnFill,
              columnGap = _node$style.columnGap,
              columnRuleColor = _node$style.columnRuleColor,
              columnRuleStyle = _node$style.columnRuleStyle,
              columnRuleWidth = _node$style.columnRuleWidth,
              columnWidth = _node$style.columnWidth;
          return _objectSpread(_objectSpread({}, extra.parse(node)), {}, {
            count: columnCount,
            fill: columnFill,
            gap: columnGap,
            ruleColor: columnRuleColor,
            ruleStyle: columnRuleStyle,
            ruleWidth: columnRuleWidth,
            width: columnWidth
          });
        }
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: node => {
        var _omitExtraAttributes = omitExtraAttributes(node.attrs, extra),
            count = _omitExtraAttributes.count,
            fill = _omitExtraAttributes.fill,
            gap = _omitExtraAttributes.gap,
            ruleColor = _omitExtraAttributes.ruleColor,
            ruleStyle = _omitExtraAttributes.ruleStyle,
            ruleWidth = _omitExtraAttributes.ruleWidth,
            width = _omitExtraAttributes.width,
            other = _objectWithoutProperties(_omitExtraAttributes, _excluded);

        var _extra$dom = extra.dom(node),
            _extra$dom$style = _extra$dom.style,
            currentStyle = _extra$dom$style === void 0 ? '' : _extra$dom$style,
            rest = _objectWithoutProperties(_extra$dom, _excluded2);

        var style = joinStyles({
          columnCount: count,
          columnFill: fill,
          columnGap: gap,
          columnRuleColor: ruleColor,
          columnRuleStyle: ruleStyle,
          columnRuleWidth: ruleWidth,
          columnWidth: width
        }, currentStyle);

        var attributes = _objectSpread(_objectSpread(_objectSpread({}, rest), other), {}, {
          style,
          [COLUMN_DATA_ATTRIBUTE]: 'true'
        });

        return ['div', attributes, 0];
      }
    });
  }
  /**
   * Add a column span attribute to all block nodes within the editor.
   */


  createSchemaAttributes() {
    var columnSpan = {
      default: null,
      parseDOM: node => {
        var _node$getAttribute;

        return (_node$getAttribute = node.getAttribute('column-span')) !== null && _node$getAttribute !== void 0 ? _node$getAttribute : 'none';
      },
      toDOM: attrs => {
        return attrs.columnSpan ? ['column-span', attrs.columnSpan === 'all' ? 'all' : 'none'] : null;
      }
    };
    return [{
      identifiers: {
        tags: [ExtensionTag.Block],
        type: 'node',
        excludeNames: ['columns']
      },
      attributes: {
        columnSpan
      }
    }];
  }
  /**
   * Toggle a column wrap around the content.
   */


  toggleColumns() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.store.commands.toggleWrappingNode.original(this.type, attrs, options.selection);
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "toggleColumns", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleColumns"), _class2.prototype)), _class2)) || _class);

export { ColumnsExtension, DEFAULT_COLUMN_ATTRIBUTES, toggleColumnsOptions };
